import { useEffect, useState } from 'react';

import Tabs from '@components/elements/Tabs';
import RecentPollsModule from './RecentPolls';
import CreatedPollsModule from './CreatedPolls';
import PledgesModule from './Pledges';
import MyIdea from './Idea';

type TabValue = 'votes' | 'created' | 'pledges' | 'ideas';
interface Tab {
  label: string;
  value: TabValue;
}

const TABS: Tab[] = [
  {
    label: 'Votes',
    value: 'votes',
  },
  {
    label: 'Pledges',
    value: 'pledges',
  },
  {
    label: 'Created Polls',
    value: 'created',
  },
  {
    label: 'Ideas',
    value: 'ideas',
  },
];

const FeedPage: React.FC = () => {
  const [tab, setTab] = useState<TabValue>('votes');
  useEffect(() => {
    console.log(tab);
  }, [tab]);

  let module;
  if (tab === 'pledges') module = <PledgesModule />;
  else if (tab === 'created') module = <CreatedPollsModule />;
  else if (tab === 'ideas') module = <MyIdea />;
  else module = <RecentPollsModule />;

  return (
    <>
      <div className="min-h-screen px-4 pt-20 pb-32 bg-repeat xl:pt-4 bg-purple bracket-pattern-purple">
        <div className="container mx-auto">
          <Tabs
            className="mb-8"
            active={{ value: tab }}
            tabs={TABS}
            onChange={(tab) => setTab(tab.value as TabValue)}
          />
          {tab === 'pledges' ? (
            <PledgesModule />
          ) : tab === 'created' ? (
            <CreatedPollsModule />
          ) : tab === 'ideas' ? (
            <MyIdea />
          ) : (
            <RecentPollsModule />
          )}
        </div>
      </div>
    </>
  );
};

export default FeedPage;
